/* eslint-disable */
import ObsClient from "./esdk-obs-browserjs-3.19.5.min";
import store from "@/store";
import { apiLogRecord } from "@/api/common";

/**
 *
 * @param {*} params
 * let params = {
 * file:file
 * accept:'png,gif',  //多个用,隔开
 * progressCb:(percent)=>{  //进度回调
 *
 *  },
 *  uploadingCb:()=>{ //上传中的回调
 *
 * }
 * uploadImg(params)
 *      .then(res => {
 *         console.log(res)
 *       })
 *       .catch(err => {
 *         console.log(err)
 *       })
 */
function uploadFileMulti(params) {
  console.log(params);
  const { cdn_config } = store.getters.vuexInitData;
  return new Promise((resolve, reject) => {
    params.obsClientData = {
      access_key_id: cdn_config.access,
      secret_access_key: cdn_config.secret,
      //临时访问秘钥，需要这个参数
      security_token: cdn_config.securitytoken,
      server: cdn_config.server,
    };
    params.bucketName = cdn_config.BucketName;
    params.objectKey = "im/file/";
    params.objectKey +=
      new Date().getTime() + "_" + parseInt(Math.random() * 100000000);
    params.objectKey += fnGetExtension(params.file)[0];
    params.cancelUpload = false;
    console.log(fnGetExtension(params.file));
    if (params.key) {
      params.objectKey = params.key;
    }
    if (!params.file) {
      let errMsg = {
        msg: "请选择文件",
      };
      reject(errMsg);
      return false;
    }
    if (
      params.accept &&
      !params.accept.includes(fnGetExtension(params.file)[1].toLowerCase())
    ) {
      let errMsg = {
        msg: `请上传符合以下格式的文件：${params.accept}`,
      };
      reject(errMsg);
      return false;
    }
    params.obsClient = new ObsClient(params.obsClientData);
    let fileSize = params.file.size;
    let partSize = 1024 * 1000;
    params.obsClient
      .initiateMultipartUpload({
        Bucket: params.bucketName,
        Key: params.objectKey,
        // Expires: params.expires,
      })
      .then(function(result) {
        let uploadId = result.InterfaceResult.UploadId;
        let partCount =
          fileSize % partSize === 0
            ? Math.floor(fileSize / partSize)
            : Math.floor(fileSize / partSize) + 1;
        let uploadPartStatus = {
          bucketName: params.bucketName,
          objectKey: params.objectKey,
          uploadId: uploadId,
          file: params.file,
          fileSize: fileSize,
          partSize: partSize,
          partCount: partCount,
          currentPartIndex: 0,
          parts: [],
        };
        doUploadPart(params.obsClient, uploadPartStatus);
      })
      .catch(function(err) {
        console.error("err:" + err);
      });
    let globalContext = {};
    globalContext.maxTaskNum = 5;
    globalContext.currentTaskNum = 0;

    function doUploadPart(obsClient, uploadPartStatus) {
      while (
        uploadPartStatus.currentPartIndex < uploadPartStatus.partCount &&
        globalContext.currentTaskNum < globalContext.maxTaskNum
      ) {
        let offset =
          uploadPartStatus.currentPartIndex * uploadPartStatus.partSize;
        let currPartSize =
          uploadPartStatus.currentPartIndex + 1 === uploadPartStatus.partCount
            ? uploadPartStatus.fileSize - offset
            : uploadPartStatus.partSize;
        let partNumber = uploadPartStatus.currentPartIndex + 1;
        globalContext.currentTaskNum++;
        uploadPartStatus.currentPartIndex++;
        obsClient
          .uploadPart({
            Bucket: uploadPartStatus.bucketName,
            Key: uploadPartStatus.objectKey,
            PartNumber: partNumber,
            UploadId: uploadPartStatus.uploadId,
            SourceFile: uploadPartStatus.file,
            Offset: offset,
            PartSize: currPartSize,
          })
          .then(function(result) {
            globalContext.currentTaskNum--;
            // 取消上传
            if (params.cancelUpload) return false;
            doUploadPart(obsClient, uploadPartStatus);
            if (result.CommonMsg.Status < 300) {
              // 上传进度；
              Progress(uploadPartStatus);
              uploadPartStatus.parts.push({
                PartNumber: partNumber,
                ETag: result.InterfaceResult.ETag,
              });
              if (
                uploadPartStatus.parts.length === uploadPartStatus.partCount
              ) {
                let _parts = uploadPartStatus.parts.sort(function(a, b) {
                  if (a.PartNumber >= b.PartNumber) {
                    return 1;
                  }
                  return -1;
                });
                obsClient.completeMultipartUpload(
                  {
                    Bucket: uploadPartStatus.bucketName,
                    Key: uploadPartStatus.objectKey,
                    UploadId: uploadPartStatus.uploadId,
                    Parts: _parts,
                  },
                  function(err, result) {
                    console.log(err, result);
                    if (!err && result.CommonMsg.Status < 300) {
                      Progress(uploadPartStatus, "end");
                      console.log("上传成功");
                      result.key = params.objectKey;
                      result.url = "//cdnimg.gamekee.com/" + params.objectKey;
                      // 上报obs上传数据
                      apiLogRecord({
                        file_url: result.url,
                        source: "im",
                      });
                      resolve(result);
                    } else {
                      let msg = err || result.CommonMsg.Code;
                      console.error(msg);
                      reject(msg);
                      // 回调错误
                      // params.error && params.error(msg);
                    }
                  }
                );
              }
            } else {
              console.error(result.CommonMsg.Code);
              // 回调错误
              reject(result);
            }
          })
          .catch(function(err) {
            console.error("err:" + err);
            // 回调错误
            reject(err);
          });
      }
    }

    // 回调进度
    function Progress(data, result) {
      // console.log(data);
      if (result && result == "end") {
        params.progressCb && params.progressCb(100);
        return;
      }
      // 当前切片
      let currentPartIndex = data.currentPartIndex;
      // 文件大小
      let fileSize = data.fileSize;
      // 分段大小
      let partSize = data.partSize;
      // 已上传大小
      let uploadSize = partSize * currentPartIndex;
      if (uploadSize > fileSize) uploadSize = fileSize;
      // 百分比进度
      let percent = ((uploadSize / fileSize) * 100).toFixed(2);
      if (!params.cancelUpload) {
        params.progressCb && params.progressCb(percent);
      }

      params.uploadingCb &&
        params.uploadingCb(function(cbParams) {
          if (cbParams && cbParams.cancelUpload) {
            params.cancelUpload = true;
          }
        });
    }
  });
}

function fnGetExtension(file) {
  let fileName = file.name;
  let patternFileExtension = /\.([0-9a-z]+)(?:[\?#]|$)/i;
  let fileExtension = fileName.match(patternFileExtension);
  return fileExtension;
}

export { uploadFileMulti };
